export const BASE_URL: string = process.env.REACT_APP_API_KEY || "";
// export const BASE_URL:string="http://localhost:8085";
// Master Product
export const PRODUCT_MASTER_FIND_MANY: string =
  BASE_URL + "/products/master-product/find-many";

export const GET_COUNT_MASTER_PRODUCT: string =
  BASE_URL + "/products/master-product/get-count-master-product";
export const PRODUCTS_BRAND_FIND_MANY: string =
  BASE_URL + "/products/brand/find-many";
export const MASTER_PRODUCT_UPDATE: string =
  BASE_URL + "/products/master-product/update";
// Product
export const PRODUCT_FIND_MANY: string =
  BASE_URL + "/products/product/find-many";
export const PRODUCT_GET_COUNT_MERCHANT_PRODUCT: string =
  BASE_URL + "/products/product/get-count-merchant-product";
export const PRODUCT_CREATE: string = BASE_URL + "/products/product/create";
export const PRODUCT_DELETE: string = BASE_URL + "/products/product/delete";
export const PRODUCT_UPDATE: string = BASE_URL + "/products/product/update";
// Stock
export const FIND_MANY_INVENTORY_BY_MERCHANT_CODE: string =
  BASE_URL + "/products/master-product/find-many-inventory-by-merchantCode";

export const SEARCH_PRODUCT_MERCHANT: string =
  BASE_URL + "/products/product/search";
